import { useRouter } from 'next/router'
// import { useState, useMemo } from 'react'
import { useState } from 'react'
import LeadForm from '#/components/LeadForm'
import Modal from '#/components/Modal'
import RequestInfo from '#/components/RequestInfo'
import { MAP_PAGE } from '#/consts/url'
import UserBlock from '#/containers/PDF/components/UserBlock'
import { useAgentsDescription } from '#/containers/PropertyDetail/hooks/useAgents'
import { logEvent } from '#/services/analytics'
import { Section } from '../common'
import Agent from './Agent'

const Agents: React.FC<{
  property: TopHap.ExtendedProperty,
  // history?: TopHap.PropertyTransaction[],
  isGuest?: boolean,
  agentInfo: TopHap.UserState['agentInfo']
// }> = ({ property, history, isGuest = false, agentInfo }) => {
}> = ({ property, isGuest = false, agentInfo }) => {
  const [requestModal, showRequestModal] = useState(false)
  const [leadForm, showLeadForm] = useState(false)
  const router = useRouter()
  const description = useAgentsDescription(property)
  // const brokerName = useMemo(() => {
  //   if (history && history.length > 0) {
  //     const lastListing = history.find(e => e.TransactionType === 'Listing') as TopHap.ListingTransaction | undefined
  //     if (lastListing?.isListHub) {
  //       return lastListing.BrokerName
  //     }
  //   }
  //   return undefined
  // }, [history])
  if (!property.Agents?.List) return null

  function closeModal() {
    showRequestModal(false)
  }

  const closeLeadForm = () => {
    showLeadForm(false)
  }

  function openModal() {
    if (!isGuest && typeof agentInfo === 'undefined') {
      showLeadForm(true)
    } else {
      showRequestModal(true)

      logEvent('select_content', {
        content_type: 'property_detail',
        item_id: 'request_info/modal_open',
        value: property.id,
        address: property.address.FullAddress,
        agent: JSON.stringify({
          name: property.Agents?.List?.MemberFullName,
          company: property.Agents?.List?.OfficeName,
          license: property.Agents?.List?.MemberStateLicense,
          member_key: property.Agents?.List?.MemberKey
        })
      })
    }
  }
  return (
    <Section description={description} id='listing_agents' title='Listing Agents'>
      <Agent
        agent={property.Agents.List}
        // listBrokerageName={brokerName}
        listBrokerageName={
          property.Agents?.List?.OfficeName ?
            property.Agents?.List?.OfficeName[0] : undefined
        }
        listBrokeragePhone={property.ListBrokeragePhone}
        requestInfo={openModal}
      />
      {property.Agents.CoList?.MemberFullName ? (
        <Agent
          agent={property.Agents.CoList}
          // listBrokerageName={brokerName}
          listBrokerageName={
            property.Agents?.List?.OfficeName ?
              property.Agents?.List?.OfficeName[1] : undefined
          }
          listBrokeragePhone={property.ListBrokeragePhone}
          requestInfo={openModal}
        />
      ) : null}

      <Modal className='w-full' visible={requestModal} onClose={closeModal}>
        <h2>{agentInfo?.displayName ? `Contact ${agentInfo.displayName}` : 'Contact an Agent'}</h2>
        {agentInfo && <UserBlock className='w-full rounded-xl border p-3' user={agentInfo} />}
        <span className='mb-1 mt-3 border-b border-border pb-2 text-sm' itemProp='telephone'>
          Fill in the contact form below
        </span>
        <RequestInfo property={property} small onClose={closeModal} />
      </Modal>

      <Modal className='w-full' visible={leadForm} onClose={closeLeadForm}>
        <LeadForm leadOrigin={router.pathname === MAP_PAGE ? 'map-detail' : 'detail'} property={property} onClose={closeLeadForm} />
      </Modal>
    </Section>
  )
}

export default Agents
